import {
    InquiryFetchArgs,
    getTotalByMonthsCounts,
    month
  } from '../../assets/ts/data/inquiry/inquiry'
  import useServerData from '../use-server-data'
  
  function useTotalByMonthCounts(fetchArgs: InquiryFetchArgs) {
    const {
      data: inquiryCount,
      error: inquiryCountError,
      fetchData: fetchInquiryCount,
      isLoading: inquiryCountIsLoading,
  
    } = useServerData<month, InquiryFetchArgs>(
      getTotalByMonthsCounts,
      fetchArgs
    )
  
    return {
      fetchInquiryCount,
      inquiryCount, // retained for backward-compatibility.  Use inquiryCountValue
      inquiryCountError,
      inquiryCountIsLoading,
    }
  }
  
  export default useTotalByMonthCounts